import React from 'react';

const BG_CLASSES = ['bg-info', 'bg-success', 'bg-warning', 'bg-danger', 'bg-primary', 'bg-secondary', 'bg-teal'];

export default function MetricSmallBox({ icon, label, value, sub, index = 0 }) {
  const bg = BG_CLASSES[index % BG_CLASSES.length];
  return (
    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
      <div className={`small-box ${bg}`}>
        <div className="inner">
          <h3>{value}</h3>
          <p>{label}</p>
          {sub ? <p className="metric-small-box-sub small mb-0 opacity-75">{sub}</p> : null}
        </div>
        <div className="icon">
          <i className={icon} />
        </div>
        <span className="small-box-footer">&nbsp;</span>
      </div>
    </div>
  );
}
